import {each, groupBy, isEmpty, uniq} from 'lodash';

import {getToken, LabelMap} from '.';
import URL_CONST from '../../config/url';
import {FILE_TYPE} from '../../components/DatasetEdit/const';
import {ItemType} from '../../base-components/StudioDataset/FileViewer';
import {BINARY_TO_LOCAL_TYPE} from '../../components/DatasetEdit/helpers';
import {
  DataPrepareTypeStrDS,
  ImageType,
} from '../../types/dataset/DatasetGetAnnotationsResponse';
import {
  CategoryList,
  DatasetMetadataBinaryItem,
  DatasetMetadataLabelItem,
  SplitDistributionCount,
} from '../../types/dataService/DatasetMetadata';

export const ITEMTYPE_TO_METADATA_MAP: {[key: string]: string} = {
  id: 'id',
  size: 'size',
  width: 'width',
  height: 'height',
  type: 'mediaType',
  created: 'created',
  lastEdited: 'updated',
  filename: 'originalPath',
};

export const getFormatterUrlFromImage = (
  image: ImageType,
  datasetId: string,
  size: number
) => {
  const token = getToken();
  let url = `${URL_CONST.DSS_DATASET_BINARIES_PREVIEW}?binaryId=${image.id}&datasetId=${datasetId}&authToken=${token}`;

  if (size) {
    url += `&previewDimensions=${size}x${size}`;
  }

  return url;
};

// Convert BE dataformat to UI binary usable format.
export const formatBinariesToLocal = (
  list: DatasetMetadataBinaryItem[],
  datasetId: string
) => {
  let formattedBinaries: ItemType[] = [];

  if (list.length > 0) {
    const token = getToken();
    formattedBinaries = list.map(image => ({
      id: image.id,
      filename: image.originalPath,
      url: `${URL_CONST.DSS_DATASET_BINARIES_PREVIEW}?binaryId=${image.id}&datasetId=${datasetId}&authToken=${token}`,
      size: image.size,
      height: image.height,
      width: image.width,
      selected: false,
      type: BINARY_TO_LOCAL_TYPE[image.type],
      binaryType: image.type,
      lastEdited: new Date(image.updated),
    }));
  }

  return formattedBinaries;
};

enum GroupOrder {
  ImagesToUpload = 1,
  VideoToUpload,
  UploadedImages,
  UploadedVideos,
}

export const getGroupLabel = (data: ItemType[] = []) => {
  if (data.length) {
    return data.map(el => {
      return {
        ...el,
        group: el.file
          ? el.type === FILE_TYPE.IMAGE
            ? GroupOrder.ImagesToUpload
            : GroupOrder.VideoToUpload
          : el.type === FILE_TYPE.IMAGE
          ? GroupOrder.UploadedImages
          : GroupOrder.UploadedVideos,
      };
    });
  }
  return [];
};

export const getLabelMap = (data: DatasetMetadataLabelItem[] = []) =>
  groupBy(data, 'binaryId');

export const getLabel = (
  binaryId: string,
  labelMap?: LabelMap,
  categories?: CategoryList,
  method?: DataPrepareTypeStrDS
) => {
  if (labelMap && categories && !isEmpty(labelMap) && !isEmpty(categories)) {
    const mapValue = labelMap[binaryId];
    if (!isEmpty(mapValue)) {
      return uniq(mapValue.map(item => categories[item.category])).join(', ');
    }
  }
  return undefined;
};

export const formatRawLabelCountArr = (
  splitDist?: SplitDistributionCount,
  categories?: CategoryList
) => {
  if (splitDist && categories) {
    const formattedData: any = [];
    each(splitDist, (count, key) => {
      const labelKey = Number(key);
      formattedData.push({
        label: categories[labelKey] || 'unlabelled',
        count,
      });
    });
    return formattedData;
  }
  return {};
};
